module.exports = __webpack_public_path__ + "img/sponsorF29.8015686e.png";